import React from 'react';
import { UID } from 'react-uid';

const EiFreeIcon = ({
  title = 'EI Free',
  decorative = true,
  className,
  size,
}) => (
  <UID>
    {(uid) => (
      <div style={{ width: size, height: size }} className={className}>
        <svg
          role="img"
          aria-hidden={decorative}
          aria-labelledby={uid}
          width="157"
          height="100"
          viewBox="0 0 157 100"
        >
          <title id={uid}>{title}</title>
          <defs>
            <linearGradient
              id="a"
              x1="88.281%"
              x2="157.989%"
              y1="73.9%"
              y2="32.089%"
            >
              <stop offset="0%" stopColor="#F8FAFF" stopOpacity="0" />
              <stop offset="100%" stopColor="#8BA3CA" />
            </linearGradient>
            <linearGradient
              id="b"
              x1="80.362%"
              x2="135.649%"
              y1="116.719%"
              y2="0%"
            >
              <stop offset="0%" stopColor="#F8FAFF" stopOpacity="0" />
              <stop offset="100%" stopColor="#8BA3CA" />
            </linearGradient>
            <linearGradient
              id="c"
              x1="88.281%"
              x2="157.989%"
              y1="101.155%"
              y2="11.663%"
            >
              <stop offset="0%" stopColor="#F8FAFF" stopOpacity="0" />
              <stop offset="100%" stopColor="#8BA3CA" />
            </linearGradient>
            <linearGradient
              id="d"
              x1="68.999%"
              x2="103.596%"
              y1="116.719%"
              y2="0%"
            >
              <stop offset="0%" stopColor="#F8FAFF" stopOpacity="0" />
              <stop offset="100%" stopColor="#8BA3CA" />
            </linearGradient>
            <linearGradient
              id="e"
              x1="59.398%"
              x2="76.511%"
              y1="116.719%"
              y2="0%"
            >
              <stop offset="0%" stopColor="#F8FAFF" stopOpacity="0" />
              <stop offset="100%" stopColor="#8BA3CA" />
            </linearGradient>
          </defs>
          <g fill="none" fillRule="evenodd">
            <g fill="#F1F5FF" opacity=".5" transform="translate(8.887)">
              <rect width="118.491" height="25.432" y="29.114" rx="12.716" />
              <rect
                width="118.491"
                height="44.879"
                x="21.476"
                y="54.545"
                rx="22.44"
              />
              <rect
                width="118.491"
                height="32.911"
                x="13.188"
                y=".575"
                rx="16.456"
              />
            </g>
            <g fillRule="nonzero" transform="translate(28.983 15.823)">
              <path
                fill="#EA5188"
                d="M35.776 15.588c-.82 0-1.625-.224-2.328-.646a.499.499 0 1 1 .518-.852c1.4.839 3.195.604 4.33-.566a3.496 3.496 0 0 0 .428-4.336.498.498 0 0 1 .39-.794.5.5 0 0 1 .45.255 4.487 4.487 0 0 1 .174 4.593 4.51 4.51 0 0 1-3.962 2.346zM74.646 51.56a.604.604 0 0 1-.534-.328 6.747 6.747 0 0 0-3.805-3.32.59.59 0 0 1-.06-1.091.599.599 0 0 1 .456-.024 7.94 7.94 0 0 1 4.477 3.901.6.6 0 0 1-.534.862z"
              />
              <path
                fill="#D6E2F5"
                d="M81.763 59.077a.35.35 0 0 1-.08.333c-.627.627-.999 1.522-1.036 2.495-.008.184-.146.316-.309.295a.306.306 0 0 1-.204-.121.378.378 0 0 1-.077-.244c.044-1.145.48-2.197 1.218-2.936.12-.116.306-.098.42.042.031.04.055.086.068.136z"
              />
              <path fill="#35DEB3" d="M30.443 44.365l-.82 2.398 2.962-1.387z" />
              <path fill="#C8D7EE" d="M84.997 49.188l2.423-.653-2.793-1.71z" />
              <path fill="#35DEB3" d="M28.038 10.792l.4-2.998-3.555 2.474z" />
              <ellipse
                cx="26.364"
                cy="18.286"
                fill="#B938D1"
                rx="1.481"
                ry="1.499"
              />
              <ellipse cx="13.33" cy="15.888" fill="#C8D7EE" rx="1" ry="1" />
              <ellipse cx="30.215" cy="31.775" fill="#EA5188" rx="1" ry="1" />
              <ellipse cx="83.536" cy="35.972" fill="#35DEB3" rx="1" ry="1" />
              <ellipse
                cx="72.575"
                cy="38.67"
                fill="#B938D1"
                rx="1.481"
                ry="1.499"
              />
              <path
                fill="url(#a)"
                d="M1.402 41.896a.955.955 0 0 1-.814-.45.99.99 0 0 1 .291-1.36l29.989-17.15a.97.97 0 0 1 1.348.306.995.995 0 0 1-.302 1.364L1.93 41.746c-.16.098-.342.15-.529.15z"
              />
              <path
                fill="url(#b)"
                d="M23.788 61.938a1 1 0 0 1 .078-1.181l22.615-25.608a.97.97 0 0 1 1.331-.048c.388.34.45.924.144 1.34L25.342 62.05c-.124.14-.282.245-.459.302a.972.972 0 0 1-1.095-.413z"
              />
              <path
                fill="url(#c)"
                d="M17.297 47.924a1.001 1.001 0 0 1 .252-1.16L42.19 25.47a.952.952 0 0 1 .98-.244 1.002 1.002 0 0 1 .283 1.739L18.818 48.264a.951.951 0 0 1-.498.224.958.958 0 0 1-1.023-.564z"
              />
              <path
                fill="url(#d)"
                d="M45.685 56.203a1.005 1.005 0 0 1-.145-1.155L57.283 37.69a.95.95 0 0 1 .84-.606.94.94 0 0 1 .88.536c.167.341.124.752-.109 1.05L47.168 56.023a.941.941 0 0 1-.371.377.93.93 0 0 1-1.112-.197z"
                transform="rotate(-4 52.263 46.793)"
              />
              <path
                fill="url(#e)"
                d="M51.918 67.689a.985.985 0 0 1-.55-1.26l12.618-27.428a.967.967 0 0 1 1.248-.569c.5.19.754.751.566 1.254L53.182 67.114a.962.962 0 0 1-.923.635 1.095 1.095 0 0 1-.34-.06z"
              />
              <path
                fill="#84A5FF"
                d="M79.389 0L51.722 35.972 45.619 23.34l-13.034-1.542z"
              />
              <path fill="#1F4ED2" d="M79.389 0L51.722 35.972 45.619 23.34z" />
              <path fill="#00173E" d="M51.722 35.972l5.153-6.672-6.517-4.12z" />
              <path fill="#C6D5FF" d="M67.563 35.972L49.766 25.414 79.389 0z" />
            </g>
            <ellipse
              cx="7.998"
              cy="65.688"
              fill="#F1F5FF"
              rx="7.998"
              ry="8.094"
            />
            <ellipse
              cx="15.996"
              cy="81.576"
              fill="#F1F5FF"
              rx="4.147"
              ry="4.197"
            />
            <ellipse
              cx="149.002"
              cy="42.906"
              fill="#F1F5FF"
              rx="7.998"
              ry="8.094"
            />
          </g>
        </svg>
      </div>
    )}
  </UID>
);

export default EiFreeIcon;
